import { load } from 'ts-dotenv'

const env = load({
  REACT_APP_SEND_FORM_URL: String,
})

export const sendForm = (flow:string, formData: any, nextStep: () => void) => {
  const request = new Request(env.REACT_APP_SEND_FORM_URL+`&form_id=${flow}`, {
    method: 'POST',
    body: JSON.stringify(formData),
    redirect: 'follow'
  })

  fetch(request)
  .then(res => res.text())
  .then(() => {
    nextStep()
  })
}

export const formatEventItems = ( raw: Array<any> ) => {
  const result = <any>[]
  console.log(raw)
  raw.forEach((el, i)=>{
    console.log('~~', raw)
    let row = Object.assign({}, el)
    delete row['sizeNQuntity']

    el.sizeNQuntity.forEach((elem:any)=> {
      const item = Object.assign( Object.assign( {}, row ), elem )
      console.log( '+', row, elem, item )
      result.push( item )
    });
    console.log(result)
  })

  return result
}

export const formatUnionItems = ( raw: Array<any> ) => {
  const result = <any>[]
  console.log(raw)
  raw.forEach((el, i)=>{
    console.log('~~', raw)
    let row = Object.assign({}, el)
    delete row['persons']

    el.persons.forEach((elem:any)=> {
      const item = Object.assign( Object.assign( {}, row ), elem )
      console.log( '+', row, elem, item )
      result.push( item )
    });
    console.log(result)
  })

  return result
}